export function LaborCostSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/labor-cost.svg'"></ng-include>`
    }
}